import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Trip from 'ferries/Home/components/FerrySearchMask/MultiTrip/Trip';
import SearchButton from 'components/SearchMask/SearchButton';

const MultiTrip = ({
  isMobile, loading, triedToSubmit, trips, noOfTrips, maxTrips, minTrips, queries,
  errors, addTrip, removeTrip, setPort, fetchSuggestions, clearSuggestions, onSuggestionSelected,
  portString, swapPorts, setTypeTrip, setDate, setDates, setPortByThreeLetterCode, fillWithQuery,
  onChangePopularPortCountry, product, submitForm, translations
}) => (
  <form className="searchMask multi-trip">
    {trips.map((trip, index) =>
      <Trip
        key={index}
        isMobile={isMobile}
        index={index}
        triedToSubmit={triedToSubmit}
        trip={trip}
        noOfTrips={noOfTrips}
        minTrips={minTrips}
        queries={queries}
        errors={errors}
        disableBefore={index > 0 && index - 1 < trips.length && trips[index - 1] ?
          trips[index - 1].obDate : {}}
        disableAfter={index >= 0 && index + 1 < trips.length && trips[index + 1] ? 
          trips[index + 1].obDate : {}}
        setPort={setPort}
        fetchSuggestions={fetchSuggestions}
        clearSuggestions={clearSuggestions}
        onSuggestionSelected={onSuggestionSelected}
        portString={portString}
        swapPorts={swapPorts}
        setTypeTrip={setTypeTrip}
        setDate={setDate}
        setDates={setDates}
        removeTrip={removeTrip}
        setPortByThreeLetterCode={setPortByThreeLetterCode}
        fillWithQuery={fillWithQuery}
        onChangePopularPortCountry={onChangePopularPortCountry}
        translations={translations}
      />
    )}
    <div className="multi-trip-controls grid">
      <div className="grid-item-md mb-3 px-2">
        <button
          className="add-trip btn btn-block btn-lg px-0"
          type="button"
          disabled={noOfTrips >= maxTrips}
          onClick={addTrip}>
          <i className="icon icon-e-add-1 mr-2"/> {translations.addOneMoreTrip}
        </button>
      </div>
      <SearchButton
        multiTrip
        product={product}
        loading={loading}
        submitForm={submitForm}
        translations={translations}
      />
    </div>
  </form>
);

MultiTrip.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  triedToSubmit: PropTypes.bool.isRequired,
  product: PropTypes.string.isRequired,
  trips: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  noOfTrips: PropTypes.number.isRequired,
  maxTrips: PropTypes.number.isRequired,
  minTrips: PropTypes.number.isRequired,
  queries: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired,
  addTrip: PropTypes.func.isRequired,
  removeTrip: PropTypes.func.isRequired,
  setPort: PropTypes.func.isRequired,
  fetchSuggestions: PropTypes.func.isRequired,
  clearSuggestions: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  portString: PropTypes.func.isRequired,
  swapPorts:PropTypes.func.isRequired,
  setTypeTrip: PropTypes.func.isRequired,
  setDate: PropTypes.func.isRequired,
  setDates: PropTypes.func.isRequired,
  setPortByThreeLetterCode: PropTypes.func.isRequired,
  fillWithQuery: PropTypes.func.isRequired,
  onChangePopularPortCountry: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    addOneMoreTrip: PropTypes.string.isRequired
  })
};

export default observer(MultiTrip);
